/**
 * Cookie policy — LEGALLY VALIDATED TEXT. Do not rephrase.
 *
 * Sentence-by-sentence translation of the French: transport, not
 * authoring. {{DUREE_SESSION}} carries the REAL session-cookie lifetime,
 * read from the authentication code (see content/legal/index.js) — the
 * token is kept as is, never copied out as a literal.
 *
 * The Belgian statute keeps its official French title, with an English
 * gloss: Belgium publishes no official English version of its laws.
 */
const COOKIES_EN = String.raw`
# Cookie policy

**Archer · archer.law**
Last updated: {{DATE_MISE_EN_LIGNE}}

*This document is available in French, Dutch and English. In case of discrepancy between language versions, the French version prevails.*

## 1. What is a cookie?

A cookie is a small file placed on your device when you visit a site. Some are indispensable to the operation of the site; others serve to measure audience or to display advertising and may only be placed with your **prior consent** (art. 129 of the Belgian law of 13 June 2005 on electronic communications, loi du 13 juin 2005 relative aux communications électroniques, and GDPR).

## 2. The cookies we use

### 2.1. Strictly necessary cookies: no consent required

They allow the site to work and cannot be disabled:

| Cookie | Purpose | Duration |
|---|---|---|
| Session / authentication | Keep you signed in to your account | Session or {{DUREE_SESSION}} |
| Security (anti-CSRF) | Protect forms against forgery | Session |
| Preferences | Remember your language and interface choices | 12 months |
| Consent | Remember your cookie choices | 6 months |

### 2.2. Advertising and measurement cookies: subject to your consent

We use (or plan to use) trackers from advertising platforms to measure the effectiveness of our campaigns and to serve relevant advertising:

| Tracker | Provider | Purpose |
|---|---|---|
| TikTok Pixel | TikTok Technology Limited | Campaign measurement, targeted advertising |
| Meta Pixel | Meta Platforms Ireland Ltd | Campaign measurement, targeted advertising |

**These trackers are never activated before your consent.** As long as you have not clicked "Accept", no advertising script is loaded and no data is transmitted to those platforms. Any data collected after consent (pages viewed, conversion events, technical identifiers) is processed by those platforms under their own policies, including outside the European Union.

## 3. Your choices

On your first visit, a banner offers you to **Accept** or **Decline** non-necessary cookies, with the same level of simplicity for both choices. Declining does not degrade your access to the Service.

You may change your choice at any time through the "**Manage my cookies**" link in the footer. Your choice is kept for 6 months, after which you are asked again.

You may also configure your browser to block or delete cookies; blocking strictly necessary cookies may however prevent you from signing in to your account.

## 4. Contact

For any question concerning cookies and trackers: bonjour@archer.law.
`;

export default COOKIES_EN;
